import { Component, OnInit, NgZone, HostListener, OnDestroy } from '@angular/core';
import { getDeviceSize, getCookie, deleteCookie, detectbrowser } from './utilities/utilities.file';
import { Router, ActivatedRoute } from '@angular/router';
import { IwService } from './services/iw.service';
import { SharedServiceService } from './services/shared-service.service';
import { IS_CAMPAIGN, ISTATACARD, REDIRECT_SWIFT_URL, TRACK_GEN_NEW_URL_DECRYPT, DECRYPT_FOR_TOKEN_CALL, ENV_CREDENTIAL } from './config/app-settings.config';
import { ThemeService } from './services/theme.service';
import { CatalogueService } from 'src/app/services/catalogue.service';
import cssVars from 'css-vars-ponyfill';
import { SBICARDTheme, base_https_url } from './config/app-settings.config';
import { filter } from 'rxjs/operators';
import { TRACK_APP } from './config/app-settings.config';
import { EncrDecrService } from './services/encr-decr-service.service';
import { LoaderService } from './services/loader.service';
import { LoaderInterceptorService } from './services/loader-interceptor.service';
import { DomSanitizer } from '@angular/platform-browser';
declare var $: any;
declare var jQuery: any;
declare var form_abandon: Function;
declare var analytics: any;
import * as uuid from 'uuid';
@Component({
  selector: 'main-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  submenu;
  title = 'eapply';
  isMobile: boolean;
  authDetails: any;
  routerparams: any;
  themeObj: any;
  errorMsg: string;
  response: any;
  themeParam: any;
  partnerCode: any
  // partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  showLoader: boolean = true;
  saveId: string;
  retrieveSaveId: string;
  isShortLeadThankYou: any;
  domainUrl: any;
  partnerCookie: any;
  partnerCookieUrl: any = false;
  partnerDetails: any;
  partnerExpiryDate: any;
  currentDate: Date;
  passphraseLocal: string;

  constructor(
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private iw: IwService,
    private themeService: ThemeService,
    private loaderService: LoaderService,
    private encryptDecService: EncrDecrService,
    private catalogueService: CatalogueService,
    private sharedService: SharedServiceService,
    public sanitizer: DomSanitizer
  ) {
    this.partnerDetails = window['authenticationDetails'] && window['authenticationDetails'].EapplyTokenGenerationResponse.partnerDetails ? window['authenticationDetails'].EapplyTokenGenerationResponse.partnerDetails : null;
    //console.log(this.partnerDetails);
    if (this.partnerDetails) {
      this.themeService.partnerDetails = this.partnerDetails;
      this.partnerCode = this.partnerDetails.partnerCode;
      this.themeService.partnerCode = this.partnerCode;
      this.iw.partnerCode = this.partnerCode;
      this.partnerExpiryDate = new Date(this.partnerDetails.expiryDate);
      this.currentDate = new Date();
      this.themeService.partnerExpiryDate = this.partnerExpiryDate;
      //console.log(this.partnerDetails.partnerCode);
      // console.log(this.encryptDecService.get("169ac3646fb78b0b192ea7e1fae195c713e484b3324609a05e95a624dd5c3a022073KcLkcOuNUHsNeCuAsosfKO4wUmMOuXcKu/67rm4="));
      let defaultUrl = sessionStorage.getItem('defaultUrl');
      defaultUrl ? history.replaceState('', '', defaultUrl) : true;
      this.domainUrl = base_https_url.split('//')[1];
      //console.log(this.domainUrl);
    }
    this.authDetails = window['authenticationDetails'] ? window['authenticationDetails'].EapplyTokenGenerationResponse.tokenGenerationResponse : '';
    if (this.authDetails) {
      sessionStorage.setItem('jwt', this.authDetails.access_token);
      sessionStorage.setItem('encryptedToken', this.authDetails.encrypted_token);
      console.log("Generating JWT form app-componet ==> ", this.authDetails.access_token);
      // document.cookie = this.authDetails['x-sbic-user-fgp'].split(';')[0] + ';Path=/';
      // if(!(this.partnerCode&&this.containerType)){
      if (this.partnerDetails && this.containerType) {
        let spaDomain = sessionStorage.getItem('spa-domain-name').split('//')[1];
        let cookieUrl = `https://${spaDomain}/sbi-card-en/resources/jsp/cookie3.jsp?key=${this.authDetails['x-sbic-user-fgp'].split(';')[0].split('=')[1]}&domain=${spaDomain}`;
        // console.log(cookieUrl);
        // this.sharedService.cookie_URL = `x-sbic-user-fgp= + ${}`;
        this.partnerCookieUrl = cookieUrl;
        let cImg = document.createElement("img");
        cImg.setAttribute('src', this.partnerCookieUrl);
        cImg.style.display = 'none';
        document.body.appendChild(cImg);
        // this.partnerCookieUrl = this.sanitizer.bypassSecurityTrustResourceUrl(cookieUrl);
        //console.log(this.partnerCookieUrl);
        document.cookie = this.authDetails['x-sbic-user-fgp'].split(';')[0] + ';Path=/';
        let cookieIndex = document.cookie.indexOf('x-sbic-user-fgp');
        let realCookie = document.cookie.slice(cookieIndex).split(';')[0];
        // this.sharedService.cookie_URL = realCookie;
        sessionStorage.setItem('cookie', realCookie);
        // console.log("document.cookie", realCookie);
      } else {
        document.cookie = this.authDetails['x-sbic-user-fgp'].split(';')[0] + ';Path=/';
        let cookieIndex = document.cookie.indexOf('x-sbic-user-fgp');
        let realCookie = document.cookie.slice(cookieIndex).split(';')[0];
        // this.sharedService.cookie_URL = realCookie;
        sessionStorage.setItem('cookie', realCookie);
        // console.log("document.cookie", realCookie);
      }
    }
    this.getDrcFromURL();
    const myId = uuid.v4();
    this.sharedService.uuidString = myId;
  }

  ngOnInit() {
    var passphrase = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var length = characters.length;
    for (var i = 0; i < 10; i++) {
      passphrase += characters.charAt(Math.floor(Math.random() * length));
    }
    console.log("passphrase=====>", passphrase);
    this.passphraseLocal = passphrase;
    this.sharedService.passphrase = passphrase;
    sessionStorage.setItem("channelName", this.sharedService.paramschannel);
    let fromSwiftJourney = sessionStorage.getItem("fromSwiftJourney");
    if (fromSwiftJourney == 'true') {
      this.sharedService.fromSwiftJourney = true;
      console.log("fromSwiftJourney set to true from app component", this.sharedService.fromSwiftJourney);
    }
    else {
      this.sharedService.fromSwiftJourney = false;
      console.log("fromSwiftJourney set to false from app component", this.sharedService.fromSwiftJourney);
    }
    let defaultUrl = sessionStorage.getItem('defaultUrl');
    defaultUrl ? history.replaceState('', '', defaultUrl) : true;
    // document.cookie="saveId=a0144187b1868d069e88bb1ebd1a7524uH6J9bigxAYpIVmKUwvzKNBe1hbvuVYF6K+4m0dhuVE=";
    if (getDeviceSize() === 'small') {
      this.isMobile = true;
    }
    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (getDeviceSize() === 'small') {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });
    };
    this.route.queryParams.subscribe(query => {
      if (query) {
        if (query.theme && query.path) {
          this.themeParam = query.theme;
          this.showLoader = true;
          this.setThemeByParam(this.themeParam);
          this.themeService.themeParam = this.themeParam;
          this.iw.themeParam = this.themeService;
          // console.log("Navigate to apply from ngOnInit app component");
          // window.location.href = `${REDIRECT_SWIFT_URL}?card=simplyClick`;
          this.router.navigate(['./apply'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType ? true : false });
        }
        else if (query.theme) {
          this.themeParam = query.theme;
          this.showLoader = true;
          this.setThemeByParam(this.themeParam);
          this.themeService.themeParam = this.themeParam;
          this.iw.themeParam = this.themeService;
          this.router.navigate(['./catalogue-partner'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType ? true : false });
        }
      }
    });
    if (this.containerType && this.partnerCode && !this.themeParam) {
      this.showLoader = true;
      this.setThemeByParam(this.partnerCode);
      this.router.navigate(['./catalogue-partner'], { queryParamsHandling: "preserve", skipLocationChange: true });
    }
    else if (this.partnerCode && !this.themeParam) {
      this.showLoader = true;
      this.setThemeByParam(this.partnerCode);
    }
    else {
      this.themeService.setThemePage(SBICARDTheme);
      cssVars({
        // rootElement   : document.getElementById('spa-content'),
        variables: SBICARDTheme
      });//Theme change for IE 
      this.showLoader = false;
    }
    this.isShortLeadThankYou = getCookie('isShortLeadThankYou');
    if (this.isShortLeadThankYou === 'true') {
      this.router.navigate(['./success']);
    }
    //Analytics for Browser Close
    window.addEventListener('beforeunload', function (e) {
      console.log('BROWSER CLOSED');

      if (window['analytics']) {
        analytics.track('eapply__journey_abondan', {
          'PAGE_NAME': window["digitalData"].page.pageName,
          'PAGE_URL': window["digitalData"].page.PAGE_URL,
          'MODE_OF_CONVERSION': '',
          'IS_ORGANIC': 'N',
          'SOURCE_GEM_ID1': '',
          'SOURCE_GEM_ID2': '',
          'SOURCE_PAGE_URL': '',
          'JOURNEY_NAME': 'EAPPLY',
          'JOURNEY_ABONDON_REASON': '',
          'card_type': sessionStorage.getItem('cardType')
        })
      }
    });


  }


  ngAfterViewInit() {
    this.authDetails = window['authenticationDetails'] ? window['authenticationDetails'].EapplyTokenGenerationResponse.tokenGenerationResponse : '';
    if (this.authDetails) {
      sessionStorage.setItem('jwt', this.authDetails.access_token);
      sessionStorage.setItem('encryptedToken', this.authDetails.encrypted_token);
      console.log("ngAfterViewInit jwt ==> ", this.authDetails.access_token);
      // document.cookie = this.authDetails['x-sbic-user-fgp'];
      document.cookie = this.authDetails['x-sbic-user-fgp'].split(';')[0] + ';Path=/';
    }


    if (this.sharedService.paramschannel == '901') {
      window["digitalData"].page = { pageName: 'sbi-card:banca:campaign', pageType: 'Banca' };
    } else if (IS_CAMPAIGN) {
      window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
    } else if (window.location.href && window.location.href.toLowerCase().includes('referralcode')) {
      window["digitalData"].page = { pageName: 'sbi-card:eapply:refer-and-earn', pageType: 'Refer and Earn' };
    } else if (window.location.href && window.location.href.toLowerCase().includes('theme=mobileapp')) {
      window["digitalData"].page = { pageName: 'sbi-card:eapply:pi-eapply', pageType: 'PI Eapply' };
    } else {
      window["digitalData"].page = { pageName: 'sbi-card:eapply:eapplyform', pageType: 'Eapply' };
    }
    window["digitalData"].decisionType = "";
    // window["digitalData"].instantDecision = "";
    window["digitalData"].eapply = { instantDecision: "" };
    window["digitalData"].application = { status: "Incomplete", number: "" };
    if (this.sharedService.cardName) {
      window["digitalData"].card = { cardName: this.sharedService.cardName };
    }
  }

  @HostListener('window:beforeunload', ['$event']) goToPage(e) {
    if (!sessionStorage.getItem('refreshed')) {
      sessionStorage.setItem('refreshed', 'true');
      form_abandon(this.sharedService.cardName, "", "")
    }
    deleteCookie('saveId');
    // deleteCookie('retrieveSaveId');

  }

  getDrcFromURL() {
    this.route.queryParams.subscribe(query => {
      console.log('All query data==>> ', query);
      if (query) {
        console.log("Value of query", query);
        let saveId = query.saveId;
        let track = query.track;       //================> added for redirection
        const urlPath = query.path;
        const referalCode = query.referralcode;
        // const theme = query.theme;
        // this.setThemeByParam(theme);
        this.sharedService.paramsappNumber = query.appNo;
        this.sharedService.paramsmobileNo = query.mobileNo;
        this.sharedService.paramsfirstName = query.fname;
        this.sharedService.paramsgemid1 = query.GEMID1;
        this.sharedService.paramsgemid2 = query.GEMID2;
        let gem11 = this.sharedService.paramsgemid1;
        console.log("Value of GEMMMM", gem11);
        this.sharedService.paramschannel = query.CHN;
        console.log("params Channel", this.sharedService.paramschannel);
        this.sharedService.paramsshortCode = query.sc;
        if (query.sc) {
          console.log("Value of ShortCode from app components ==> ", query.sc);
          if (query.obc) {
            console.log("Value of OBC from app components ==> ", query.obc);
            this.sharedService.paramsObc = query.obc;
            sessionStorage.setItem('obc', query.obc);
          }
          sessionStorage.setItem('sc', query.sc);
          this.sharedService.paramsshortCode = query.sc;
        }
        if (query.CHN) {
          sessionStorage.setItem('channelId', query.CHN);
          this.sharedService.paramschannel = query.CHN;
        }
        //Changes to redirection journey

        if (track) {
          console.log("navigate to complete application from app component");
          let request = ENV_CREDENTIAL.channel;
          console.log("Request Test1", request);
          this.sharedService.callForToken(request).subscribe((response: any) => {
            if (response) {
              response = DECRYPT_FOR_TOKEN_CALL ? this.encryptDecService.getNew(response, this.passphraseLocal) : response;
              console.log("callForToken reponse", response);
              sessionStorage.setItem('jwt_new', response.accessToken);
              sessionStorage.setItem('cookie_new', response.sbicUserFgp);
              let requestBody = {
                data: {
                  hsToken: track,
                  dsignString: this.sharedService.uuidString
                },
                action: "TrackHSToken",
                type: "Swift App"
              }
              this.sharedService.trackAppAuth(requestBody).subscribe((res: any) => {
                if (res) {
                  res = TRACK_GEN_NEW_URL_DECRYPT ? this.encryptDecService.get(res) : res;
                  console.log("Track auth res => ", res);
                  console.log("Track auth req => ", requestBody);
                }
                if (res && res.status && res.status.toLowerCase() == "success") {
                  if (res.statusCode === "000") {
                    this.sharedService.trackApplicationResponse = res;
                    this.sharedService.applicantName = res.data.applicantDetails.firstName;
                    this.sharedService.applicantApplicationNumber = res.data.applicationNumber;
                    this.sharedService.fromSwiftJourney = true;
                    this.sharedService.navigateToCompleteApp = res.data.enableDataCaptureFlag;
                    this.sharedService.navigateToDocUpload = res.data.enableDocumentListFlag;
                    this.sharedService.navigateToScheduleAppointment = res.data.enableAppointmentFlag;
                    this.sharedService.navigateToAddon = res.data.enableAddOnListFlag;
                    this.sharedService.navigateToCrossSell = res.data.enableCrossSellFlag;
                    this.sharedService.navigateToResheduleAppointment = res.data.enableReSchdAppointmentFlag;
                    if (this.sharedService.navigateToCompleteApp) {
                      this.router.navigate(['/', 'complete-application']);
                    }
                    else {
                      this.router.navigate(['/apply', 'track-app']);
                    }
                    // if(res.data.statusCode == 'FFMP' || res.data.statusCode == 'DCQV') {
                    //   this.router.navigate(['/', 'complete-application']);
                    // }
                    // else{
                    //   this.router.navigate(['/apply', 'track-app']);
                    // }
                    // this.router.navigate(['/', 'complete-application']);
                  }
                }
                else {
                  this.sharedService.abortMessage = TRACK_APP.trackError;
                  this.router.navigate(['/track-application', 'track-error']);
                }
              }, error => {
                console.log("Error has occured:", error);
                this.sharedService.abortMessage = TRACK_APP.trackError;
                this.router.navigate(['/track-application', 'track-error']);
              });
            }
          }, error => {
            console.log("Error has occured:", error);
            this.sharedService.abortMessage = TRACK_APP.trackError;
            this.router.navigate(['/track-application', 'track-error']);
          });
          console.log("navigate to complete application from app component");


          // track = this.encryptDecService.decryptTeamsite(track);
          // console.log("track decrypted from app component", track);
          // let keyValuePairs = track.indexOf('&')>=1 ? track.split('&'): saveId;
          // if(Array.isArray(keyValuePairs)){

          //   keyValuePairs.forEach(e=>{
          //     let keyName= e.substr(0,e.indexOf('='))? e.substr(0,e.indexOf('=')).trim() :'';
          //     if(keyName=='fname'){
          //       this.sharedService.paramsfirstName = e.substr(e.indexOf('=')+1); 
          //     } else if(keyName=='mobileNo'){
          //       this.sharedService.paramsmobileNo = e.substr(e.indexOf('=')+1); 
          //     }
          //   })
          //   console.log('values', this.sharedService.paramsfirstName, this.sharedService.paramsmobileNo);

          // } else{
          //   let keyName= keyValuePairs.substr(0,keyValuePairs.indexOf('='))? keyValuePairs.substr(0,keyValuePairs.indexOf('=')).trim() :'';
          //    if(keyName=='appNo'){
          //      this.sharedService.paramsappNumber = keyValuePairs.substr(keyValuePairs.indexOf('=')+1);
          //    }
          //    console.log('app no value', this.sharedService.paramsappNumber);
          // }
        }
        //=========================================================================
        if (saveId) {
 
          //console.log('encryptes text', saveId);
          saveId = this.encryptDecService.decryptTeamsite(getCookie('saveId'));
              //console.log('saveid Decrypted', saveId);

              let keyValuePairs = saveId.indexOf('&') >= 1 ? saveId.split('&') : saveId;
              if (Array.isArray(keyValuePairs)) {

                keyValuePairs.forEach(e => {
                  let keyName = e.substr(0, e.indexOf('=')) ? e.substr(0, e.indexOf('=')).trim() : '';
                  if (keyName == 'fname') {
                    this.sharedService.paramsfirstName = e.substr(e.indexOf('=') + 1);
                  } else if (keyName == 'mobileNo') {
                    this.sharedService.paramsmobileNo = e.substr(e.indexOf('=') + 1);
                  }
                })
                //console.log('values', this.sharedService.paramsfirstName, this.sharedService.paramsmobileNo);

              } else {
                let keyName = keyValuePairs.substr(0, keyValuePairs.indexOf('=')) ? keyValuePairs.substr(0, keyValuePairs.indexOf('=')).trim() : '';
                if (keyName == 'appNo') {
                  this.sharedService.paramsappNumber = keyValuePairs.substr(keyValuePairs.indexOf('=') + 1);
                }
                //console.log('app no value', this.sharedService.paramsappNumber);
              }

        }

        if (query.docUpload) {
          const requestApp = {
            "applicationNumber": sessionStorage.getItem('appNo')
          }
          this.sharedService.getExpandUrlForDocUplod(requestApp).subscribe((response: any) => {
            console.log("fetch params from app component 424");
            const res = { ...response.body };
            if (res && res.FetchDocUploadParamsRsType && res.FetchDocUploadParamsRsType.status) {
              let accessToken: any;
              let expiryTime: any;
              if (response.headers && response.headers.get("access_token")) {
                accessToken = response.headers.get("access_token");
              }
              if (response.headers && response.headers.get("expiry_time")) {
                expiryTime = response.headers.get("expiry_time");
              }

              if (accessToken) {
                sessionStorage.setItem("s24_access_token", accessToken);
              }
              if (expiryTime) {
                sessionStorage.setItem("s24_expiry_time", expiryTime);
              }
              const docUploadStatus = res.FetchDocUploadParamsRsType.docUploadStatusFlag
              if (docUploadStatus == 'Y' || docUploadStatus == 'N' || docUploadStatus == 'D') {
                this.sharedService.navigateToDocUpload = false;
              } else if (docUploadStatus == 'I' || docUploadStatus == '') {
                this.sharedService.navigateToDocUpload = true;
              }
              this.sharedService.cAprofessisonalData = JSON.parse(sessionStorage.getItem('offAdd'));
              this.sharedService.qdeSubmitData = JSON.parse(sessionStorage.getItem('currentAdd'));
              this.sharedService.cApersonalData = JSON.parse(sessionStorage.getItem('perAdd'));
              this.sharedService.trackApplicationResponse = JSON.parse(sessionStorage.getItem('trackResponse'));
              this.sharedService.applicantName = sessionStorage.getItem('applicantName');
              this.sharedService.flagsFromQdeResponse = JSON.parse(sessionStorage.getItem('qdeResponseFlags'));
              this.sharedService.qdeSuccessResponse = this.sharedService.flagsFromQdeResponse ? this.sharedService.flagsFromQdeResponse.qdeResponse : '';
              this.sharedService.officeCity = sessionStorage.getItem('officeCity');
              this.sharedService.officeState = sessionStorage.getItem('officeState');
              this.sharedService.resiState = sessionStorage.getItem('resiState');
              this.sharedService.cardName = sessionStorage.getItem('cardName');

              if (this.sharedService.flagsFromQdeResponse) {
                this.sharedService.applicantApplicationNumber = this.sharedService.qdeSuccessResponse.applicationNumber;
                this.sharedService.navigateToScheduleAppointment = this.sharedService.flagsFromQdeResponse.enableAppointmentFlag;
                this.sharedService.navigateToAddon = this.sharedService.flagsFromQdeResponse.enableAddOnListFlag;
                this.sharedService.navigateToCrossSell = this.sharedService.flagsFromQdeResponse.enableCrossSellFlag;
                this.sharedService.navigateToResheduleAppointment = this.sharedService.flagsFromQdeResponse.enableReSchdAppointmentFlag ? this.sharedService.flagsFromQdeResponse.enableReSchdAppointmentFlag : false;
                this.sharedService.sbic_card_Type = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallCardType ? this.sharedService.qdeSubmitData.WSCallCardType : '';
                window["digitalData"].decisionType = this.sharedService.qdeSuccessResponse.statusCode;
                window["digitalData"].instantDecision = this.sharedService.qdeSuccessResponse.statusDesc;
                this.sharedService.sbic_card_Type = sessionStorage.getItem('cardType');

              } else if (this.sharedService.trackApplicationResponse) {
                if (this.sharedService.fromSwiftJourney) {
                  this.sharedService.applicantApplicationNumber = this.sharedService.trackApplicationResponse.data.applicationNumber;
                  this.sharedService.applicantName = this.sharedService.trackApplicationResponse.data.applicantDetails.firstName;
                  this.sharedService.navigateToScheduleAppointment = this.sharedService.trackApplicationResponse.data.enableAppointmentFlag;
                  this.sharedService.navigateToAddon = this.sharedService.trackApplicationResponse.data.enableAddOnListFlag;
                  this.sharedService.navigateToCrossSell = this.sharedService.trackApplicationResponse.data.enableCrossSellFlag;
                  this.sharedService.navigateToResheduleAppointment = this.sharedService.trackApplicationResponse.data.enableReSchdAppointmentFlag;
                  this.sharedService.sbic_card_Type = this.sharedService.trackApplicationResponse.data.cardType;
                  window["digitalData"].decisionType = this.sharedService.trackApplicationResponse.data.statusCode;
                  window["digitalData"].instantDecision = this.sharedService.trackApplicationResponse.data.statusDescription;
                  this.sharedService.sbic_card_Type = this.sharedService.trackApplicationResponse.data.cardType;
                }
                else {
                  this.sharedService.applicantApplicationNumber = this.sharedService.trackApplicationResponse.applicationNumber;
                  this.sharedService.applicantName = this.sharedService.trackApplicationResponse.eapplyApplicantDetails.firstName;
                  this.sharedService.navigateToScheduleAppointment = this.sharedService.trackApplicationResponse.enableAppointmentFlag;
                  this.sharedService.navigateToAddon = this.sharedService.trackApplicationResponse.enableAddOnListFlag;
                  this.sharedService.navigateToCrossSell = this.sharedService.trackApplicationResponse.enableCrossSellFlag;
                  this.sharedService.navigateToResheduleAppointment = this.sharedService.trackApplicationResponse.enableReSchdAppointmentFlag;
                  this.sharedService.sbic_card_Type = this.sharedService.trackApplicationResponse.cardType;
                  window["digitalData"].decisionType = this.sharedService.trackApplicationResponse.statusCode;
                  window["digitalData"].instantDecision = this.sharedService.trackApplicationResponse.statusDescription;
                  this.sharedService.sbic_card_Type = this.sharedService.trackApplicationResponse.cardType;
                }
              }

              if (sessionStorage.getItem('channelId') == '901') {
                window["digitalData"].page = { pageName: 'sbi-card:banca:campaign', pageType: 'Banca' };
              } else if (sessionStorage.getItem('campaign') == 'true') {
                window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
              } else if (sessionStorage.getItem('sc')) {
                window["digitalData"].page = { pageName: 'sbi-card:reapply:reapply', pageType: 'reapply' };
              } else {
                window["digitalData"].page = { pageName: 'sbi-card:eapply:eapplyform', pageType: 'Eapply' };
              }
              // window["digitalData"].decisionType = "";

              window["digitalData"].eapply = { number: this.sharedService.applicantApplicationNumber };
              window["digitalData"].application = { status: "complete" };
              if (this.sharedService.cardName) {
                window["digitalData"].card = { cardName: this.sharedService.cardName };
              }
              this.router.navigate(['./schedule-appointment'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType ? true : false });
            } else {
              this.sharedService.abortMessage = TRACK_APP.trackError;
              this.router.navigate(['/error'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
            }
          }, err => {
            this.sharedService.abortMessage = TRACK_APP.trackError;
            this.router.navigate(['/error'], { skipLocationChange: this.partnerCode && this.containerType ? true : false });
          })

          // expan service end
          // } else if (query.sc || this.sharedService.paramsappNumber || (this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName)) {
        } else if (this.sharedService.paramsshortCode || this.sharedService.paramsappNumber || (this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName)) {

          let request = ENV_CREDENTIAL.channel;
          console.log("Request Test2", request);
          this.sharedService.callForToken(request).subscribe((response: any) => {
            console.log("encrypted response", response);
            if (response) {
              response = DECRYPT_FOR_TOKEN_CALL ? this.encryptDecService.getNew(response, this.passphraseLocal) : response;
              console.log("callForToken reponse", response);
              sessionStorage.setItem('jwt_new', response.accessToken);
              sessionStorage.setItem('cookie_new', response.sbicUserFgp);
              if (this.sharedService.paramsmobileNo && this.sharedService.paramsfirstName) {
                if (!(detectbrowser().toUpperCase().includes('IE'))) {
                  const referrer = document.referrer;
                  //console.log("referal hereeeee app component", referrer)
                  let domain = ISTATACARD ? "tata" : "sbicard";// To be changed for PROD
                  // let domain = ISTATACARD ? "tatacard" : "sbicard";// To be changed for PROD
                  if (!(referrer.indexOf(domain) > -1)) {
                    this.sharedService.abortMessage = TRACK_APP.trackError;
                    return this.router.navigate(['/error'], { replaceUrl: true });
                  }
                }
              }
              this.router.navigate(['./track-application'], { queryParamsHandling: "preserve", replaceUrl: true, skipLocationChange: this.partnerCode && this.containerType ? true : false });
              // this.router.navigate(['./track-application'], { queryParamsHandling: "preserve" });
              
            }
          }, error => {
            console.log("Error has occured:", error);
            this.sharedService.abortMessage = TRACK_APP.trackError;
            this.router.navigate(['/track-application', 'track-error']);
          });

          


        } else if (urlPath || query.CHN) {
          // console.log("Else if condition form app-component ===>", urlPath);
          // window.location.href = `${REDIRECT_SWIFT_URL}?card=simplyClick`;
          this.router.navigate(['./apply'], { queryParamsHandling: "preserve", replaceUrl: true, skipLocationChange: this.partnerCode && this.containerType ? true : false });
          // this.router.navigate(['./apply'], { queryParamsHandling: "preserve" });
        }
        // else if (urlPath || query.CHN) {
        //   this.router.navigate(['./track-app'], {?queryParamsHandling:?"preserve"?});
        // }
        // else if(query.theme){
        //   this.themeParam = query.theme;
        //   this.themeService.themeParam = this.themeParam;
        //   this.router.navigate(['./catalogue-partner'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
        // } 
        // else if(query.page){
        //   // this.themeParam = query.theme;
        //   // this.themeService.themeParam = this.themeParam;
        //   this.router.navigate(['./catalogue-partner'], { skipLocationChange: true });
        // } 
        // else {
        //   this.router.navigate(['./catalogue-partner'], { queryParamsHandling: "preserve" });
        // }
        else if (referalCode) {
          this.router.navigate(['./catalogue-refer'], { queryParamsHandling: "preserve", replaceUrl: true });
        }
      }
    });
  }

  ngOnDestroy() {
    deleteCookie('saveId');
    deleteCookie('e-apply-data');
    // deleteCookie('retrieveSaveId');
  }
  // getTheme(id) {
  //   if (id == 'airindiaTheme') {
  //     return airindiaTheme;
  //   } else if (id == 'OLATheme') {
  //     return OLATheme;
  //   } else {
  //     return SBICARDTheme;
  //   }
  // }

  setThemeByParam(theme) {
    this.themeParam = theme;
    //console.log(this.themeParam);
    this.getThemeFromService(theme);
    //console.log("this.getThemeFromService(theme)");
    this.themeService.themeParam = this.themeParam;
    // this.themeObj = this.getTheme(this.routerparams);
    // console.log(this.themeObj);
    // this.themeService.setThemePage(this.themeObj);
    // cssVars({ variables: this.themeObj });//Theme change for IE
  }

  getThemeFromService(theme) {
    this.themeService.getThemeData(theme).subscribe((result: any) => {
      if (result) {
        if (result.partner_id && result.partner_id === theme) {
          this.response = result;
          this.themeObj = this.response;
          this.themeService.setThemePage(this.themeObj);
          cssVars({
            // rootElement   : document.getElementById('spa-content'),
            variables: this.themeObj
          });//Theme change for IE 
          this.showLoader = false;
        } else {
          this.errorMsg = 'JSON not found';
          this.themeService.setThemePage(SBICARDTheme);
          cssVars({
            // rootElement   : document.getElementById('spa-content'),
            variables: SBICARDTheme
          });//Theme change for IE 
          this.showLoader = false;
        }
      } else {
        this.errorMsg = 'JSON error';
        this.themeService.setThemePage(SBICARDTheme);
        cssVars({
          // rootElement   : document.getElementById('spa-content'),
          variables: SBICARDTheme
        });//Theme change for IE 
        this.showLoader = false;
      }
    },
      (error) => {
        this.errorMsg = 'Service not available';
        this.themeService.setThemePage(SBICARDTheme);
        cssVars({
          // rootElement   : document.getElementById('spa-content'),
          variables: SBICARDTheme
        });//Theme change for IE 
        this.showLoader = false;
      }
    );
  }
}
